import { useLayoutEffect } from 'react';

export function usePreventScroll(isChrome?: boolean) {
	const bodyFixPosition = () => {
		if (!document.body.hasAttribute('data-body-scroll-fix')) {
			const scrollPosition = Math.round(document.documentElement.scrollTop);
			document.body.setAttribute('data-body-scroll-fix', scrollPosition.toString());
			document.body.style.top = `-${scrollPosition}px`;
			document.body.setAttribute('modal-open', 'true');
		}
	};

	const bodyUnfixPosition = () => {
		if (document.body.hasAttribute('data-body-scroll-fix')) {
			document.body.removeAttribute('data-body-scroll-fix');
			document.body.removeAttribute('modal-open');
			const scrollY = document.body.style.top;
			document.body.style.top = '';

			window.scrollTo(0, parseInt(scrollY || '0') * -1);
		}
	};

	useLayoutEffect(() => {
		if (!isChrome) {
			bodyFixPosition();
		}

		return () => {
			bodyUnfixPosition();
		};
	}, []);
}
